"use client";

import React, { useState } from "react";
import "../styles/Hero.css";
import Form from "./Form";
import Modal from "./Modal";
import heroImage from "../assets/images/heroimage1.png";

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <section className="hero-section">
        {/* Background Image */}
        <img src={heroImage} alt="Hero" className="hero-bg" />

        <img src={heroImage} alt="Hero Mobile" className="hero-mobile-img" />

        {/* Left-side gradient overlay */}
        <div className="hero-overlay"></div>

        <div className="hero-container">
          {/* Left Content */}
          <div className="hero-left">
            <h1 className="hero-title">
              Ashtech Presidential Towers
            </h1>

            <p className="hero-subtitle">
              Ultra-Luxury 3 & 4 BHK Residences at Greater Noida
            </p>

            <div className="hero-offer-card">
              <p className="offer-heading">Exclusive Launch Offers</p>
              <div className="offer-details">
                <div>
                  <p className="offer-small">Starting From</p>
                  <p className="offer-price">₹2.5 Cr*</p>
                </div>
                <div className="offer-tnc">
                  <p>T & C</p>
                  <p>Apply</p>
                </div>
              </div>
            </div>

            {/* Book Button to open Modal */}
            <button
              className="hero-btn"
              onClick={() => setIsModalOpen(true)}
            >
              Book a Site Visit
            </button>
          </div>

          {/* Right Side: Floating Enquire Form (Hover-based) */}
          <Form />
        </div>
      </section>

      {/* Modal containing the Form */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="modal-form-wrapper">
          {/* <h3>Book a Private Site Visit</h3> */}
          <Form />
        </div>
      </Modal>
    </>
  );
};

export default Hero;
